import type { SVGProps } from 'react'
const SvgSyPipe = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M5.965 15.17c-.552.148-.828.222-.917.464s.059.46.356.893a8 8 0 0 0 9.66 2.863 8 8 0 0 0-2.441-15.365c-.524-.041-.786-.062-.951.137s-.092.475.056 1.028l1.643 6.132.003.01c.012.044.054.196.073.347a1.64 1.64 0 0 1-.202 1.04 1.64 1.64 0 0 1-.8.695c-.14.058-.292.098-.337.11l-.01.002z"
			clipRule="evenodd"
		/>
		<path d="M9.67 3.307c-.124-.464-.186-.695-.383-.796s-.407-.022-.827.136a10 10 0 0 0-6.33 10.964c.073.443.109.664.295.784.187.12.418.059.882-.066l7.727-2.07c.455-.122.683-.183.787-.363.103-.179.042-.407-.08-.862z" />
	</svg>
)
export default SvgSyPipe
